module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAAAv0lEQVQ4T2N06P69nZnxX/HeEvZrDCQCRofu3/8ZGBj+/GdgnMXIyFx/oITxDbFmwDTD1H9gYGRoEf3CMnl1A+MvQoaga4aqZ7zzn4Gh7GApy3p8BuDQDNdy4B/T/6JDxWznsRlCSDPDfwaGfwyMjAv+MTPXHC5kfI5sCEHNSIq/MDAwdPxkZuk7XsT4HSROimawOf8Z/j9iYGSqOFjMvIJkzUgumUCyZnJtJt3PlIQ2OfFMXgojK22TnavIzs8AOnJ/Zc3lu9gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 1